import React from 'react';
import PropTypes from 'prop-types';
import Row from 'components/UI/Layout/Row';

function ErrorMessage({
    className, errorMessage, innerClassName,
})
{
    return errorMessage ? (
        <Row className={`tw-mb-1 tw-mt-1 tw-justify-center ${className}`}>
            <span className={`tw-font-bold tw-text-red-800 dark:tw-text-red-300 ${innerClassName}`}>{errorMessage}</span>
        </Row>
    ) : '';
}

ErrorMessage.defaultProps = {
    innerClassName: '',
    className: '',
    errorMessage: '',
};

ErrorMessage.propTypes = {
    className: PropTypes.string,
    errorMessage: PropTypes.string,
    innerClassName: PropTypes.string,
};

export default ErrorMessage;
